import { IUser } from '../../interfaces'

export const addUserAction = (user: IUser) => user

export const clearUserDataAction = (): IUser => ({ email: '' })
